module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8686/img/pumpkin.svg"